/**
 * @generated SignedSource<<64f3f61a61ba75c23668392318c1c2d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMcpServerRouteQuery$variables = {
  serverId: any;
};
export type EditMcpServerRouteQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"EditMcpServerRoute_server">;
  } | null | undefined;
};
export type EditMcpServerRouteQuery = {
  response: EditMcpServerRouteQuery$data;
  variables: EditMcpServerRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serverId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serverId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMcpServerRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EditMcpServerRoute_server"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMcpServerRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "authType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discoveredTools",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toolCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resourceCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenAuthMethodOverride",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOauthAuthorized",
                "storageKey": null
              }
            ],
            "type": "GraphQLCustomMcpServer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "639cc399aaf2fec9fec48ff5de7eb10c",
    "id": null,
    "metadata": {},
    "name": "EditMcpServerRouteQuery",
    "operationKind": "query",
    "text": "query EditMcpServerRouteQuery(\n  $serverId: GlobalID!\n) {\n  node(id: $serverId) {\n    __typename\n    ...EditMcpServerRoute_server\n    __isNode: __typename\n    id\n  }\n}\n\nfragment EditMcpServerRoute_server on GraphQLCustomMcpServer {\n  id\n  name\n  slug\n  description\n  url\n  authType\n  isActive\n  discoveredTools\n  toolCount\n  resourceCount\n  tokenAuthMethodOverride\n  isOauthAuthorized\n}\n"
  }
};
})();

(node as any).hash = "89ab75cfe12aa98fa66ec03e326a209c";

export default node;
